// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Container,
//   Paper,
//   TextField,
//   Button,
//   Typography,
//   Box,
//   Alert,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
// } from "@mui/material";
// import {
//   Visibility,
//   VisibilityOff,
//   Login as LoginIcon,
// } from "@mui/icons-material";
// import { useAuth } from "../contexts/AuthContext";
// import ReCAPTCHA from "react-google-recaptcha";

// const Login = () => {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [recaptchaToken, setRecaptchaToken] = useState("");

//   const { login, token } = useAuth();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (token) {
//       navigate("/dashboard");
//     }
//   }, [token, navigate]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     if (!username || !password) {
//       setError("Please enter both username and password");
//       setLoading(false);
//       return;
//     }

//     try {
//       const payload = { username, password };
//       const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
//       // If Captcha enabled via env, require token and include in payload
//       if (siteKey) {
//         if (!recaptchaToken) {
//           setError("Please complete the captcha");
//           setLoading(false);
//           return;
//         }
//         payload.recaptcha_token = recaptchaToken;
//       }

//       const result = await login(
//         payload.username,
//         payload.password,
//         payload.recaptcha_token
//       );

//       if (result.success) {
//         navigate("/dashboard");
//       } else {
//         setError(result.error || "Login failed");
//       }
//     } catch (error) {
//       setError("An unexpected error occurred");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleTogglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   return (
//     <Container component="main" maxWidth="sm">
//       <Box
//         sx={{
//           minHeight: "100vh",
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <Paper
//           elevation={3}
//           sx={{
//             padding: 4,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             width: "100%",
//             maxWidth: 400,
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               mb: 3,
//             }}
//           >
//             <LoginIcon sx={{ fontSize: 40, color: "primary.main", mr: 1 }} />
//             <Typography component="h1" variant="h4" fontWeight="bold">
//               Login
//             </Typography>
//           </Box>

//           <Typography
//             variant="h6"
//             color="text.secondary"
//             textAlign="center"
//             mb={3}
//           >
//             Excel to PostgreSQL System
//           </Typography>

//           {error && (
//             <Alert severity="error" sx={{ width: "100%", mb: 2 }}>
//               {error}
//             </Alert>
//           )}

//           <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
//             <TextField
//               margin="normal"
//               required
//               fullWidth
//               id="username"
//               label="Username"
//               name="username"
//               autoComplete="username"
//               autoFocus
//               value={username}
//               onChange={(e) => setUsername(e.target.value)}
//               disabled={loading}
//             />

//             <TextField
//               margin="normal"
//               required
//               fullWidth
//               name="password"
//               label="Password"
//               type={showPassword ? "text" : "password"}
//               id="password"
//               autoComplete="current-password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               disabled={loading}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={handleTogglePasswordVisibility}
//                       onMouseDown={(e) => e.preventDefault()}
//                       edge="end"
//                       disabled={loading}
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             {import.meta.env.VITE_RECAPTCHA_SITE_KEY && (
//               <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
//                 <ReCAPTCHA
//                   sitekey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
//                   onChange={(token) => setRecaptchaToken(token || "")}
//                 />
//               </Box>
//             )}

//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               sx={{ mt: 3, mb: 2, py: 1.5 }}
//               disabled={loading}
//               startIcon={
//                 loading ? <CircularProgress size={20} /> : <LoginIcon />
//               }
//             >
//               {loading ? "Signing in..." : "Sign In"}
//             </Button>
//           </Box>

//           <Box sx={{ mt: 2, textAlign: "center" }}>
//             <Typography variant="body2" color="text.secondary">
//               Contact your administrator for account access
//             </Typography>
//           </Box>
//         </Paper>
//       </Box>
//     </Container>
//   );
// };

// export default Login;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  InputAdornment,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useAuth } from "../contexts/AuthContext";
import ReCAPTCHA from "react-google-recaptcha";

// Import your logo image file (place the logo in your project's assets folder)
import Logo from "../assets/logo1.png"; // adjust path accordingly

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState("");

  const { login, token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!username || !password) {
      setError("Please enter both username and password");
      setLoading(false);
      return;
    }

    try {
      const payload = { username, password };
      const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
      if (siteKey) {
        if (!recaptchaToken) {
          setError("Please complete the captcha");
          setLoading(false);
          return;
        }
        payload.recaptcha_token = recaptchaToken;
      }

      const result = await login(
        payload.username,
        payload.password,
        payload.recaptcha_token
      );

      if (result.success) {
        navigate("/dashboard");
      } else {
        setError(result.error || "Login failed");
      }
    } catch (error) {
      setError("An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            maxWidth: 400,
          }}
        >
          {/* Logo Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mb: 3,
            }}
          >
            <img
              src={Logo}
              alt="Excel to PostgreSQL Logo"
              style={{ width: "150px", height: "80px" }}
            />
          </Box>

          <Typography
            variant="h6"
            color="text.secondary"
            textAlign="center"
            mb={3}
          >
            Excel to PostgreSQL System
          </Typography>

          {error && (
            <Alert severity="error" sx={{ width: "100%", mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type={showPassword ? "text" : "password"}
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleTogglePasswordVisibility}
                      onMouseDown={(e) => e.preventDefault()}
                      edge="end"
                      disabled={loading}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {import.meta.env.VITE_RECAPTCHA_SITE_KEY && (
              <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
                <ReCAPTCHA
                  sitekey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
                  onChange={(token) => setRecaptchaToken(token || "")}
                />
              </Box>
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, py: 1.5 }}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : null}
            >
              {loading ? "Logging in..." : "Login In"}
            </Button>
          </Box>

          <Box sx={{ mt: 2, textAlign: "center" }}>
            <Typography variant="body2" color="text.secondary">
              Contact your administrator for account access
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
